export default __webpack_public_path__ + "img/17402684c2a5af8283ba612aa7633a58.png";